module.exports = __webpack_public_path__ + "img/liftIcon15.d7e2cb95.png";